module.exports = __webpack_public_path__ + "img/BR500.f2ebd512.svg";